import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faGameConsoleHandheld } from '@fortawesome/pro-duotone-svg-icons';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { LocalDataStoreService } from 'src/app/core/services/local-data-store.service';
import { LicenseTypes } from 'src/app/shared/models/enums/license-types';
import { License } from 'src/app/shared/models/license.model';

@Component({
	selector: 'app-kiosk-license',
	templateUrl: './kiosk-license.component.html',
	styleUrls: ['../kiosk.styles.scss'],
})
export class KioskLicenseComponent implements OnInit {
	@Input() venueKey: number;

	@Input() licensed: boolean;
	@Output() licensedChange = new EventEmitter<boolean>();

	licenseKey: string;
	licenseName: string;

	availableLicenses: License[] = [];
	constructor(public app: AppService, private focuslink: FocuslinkService, private localStorage: LocalDataStoreService) {}

	ngOnInit(): void {
		this.getLicenses();
	}

	async getLicenses() {
		this.app.loading(true);
		const resp = await this.focuslink.licensesGetByVenue(this.venueKey, LicenseTypes.KioskDevice);
		this.availableLicenses = resp.map((i) => new License(i)).filter((i) => !i.claimed);
		this.app.loading(false);
	}

	async licenseClaim(licenseKey: string) {
		const body = {
			key: licenseKey,
			venueKey: this.venueKey,
			mac: this.app.uuidv4(),
			name: this.licenseName,
		};
		this.app.loading(true);
		try {
			const resp = await this.focuslink.licenseClaim(body);
			console.log(resp);
			this.localStorage.set('kioskUUID', body.mac);
			this.localStorage.set('kioskLicenseKey', licenseKey);
			this.localStorage.set('kioskLicenseSecret', resp.secret);
			this.licensed = true;
		} catch (error) {
			console.log(error);
		}

		this.app.loading(false);
	}
}
